"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLog = void 0;
class EventLog {
    constructor() {
        this.events = [];
    }
    append(event) {
        this.events.push(event);
    }
    getEvents() {
        return [...this.events];
    }
    getEventsForBoard(boardId) {
        return this.events.filter(e => e.boardId === boardId);
    }
    getEventsAfterTick(tick) {
        return this.events.filter(e => e.tick > tick);
    }
    getEventsUpToTick(tick) {
        return this.events.filter(e => e.tick <= tick);
    }
    truncateAfterTick(tick) {
        this.events = this.events.filter(e => e.tick <= tick);
    }
    clear() {
        this.events = [];
    }
    get count() {
        return this.events.length;
    }
}
exports.EventLog = EventLog;



//////////////////
// WEBPACK FOOTER
// ../engine/dist/EventLog.js
// module id = 1/pZ
// module chunks = 0